import styled from 'styled-components';
import {ENABLE_HOVER_ANIMATION, GAME_BOX} from '../../../css-constants';

export const GameInfoContainerDefaultBox = styled.div<{hasTwoLinesTitle: boolean}>`
  transition: all 0.3s ease-in-out;
  padding-bottom: ${props => props.hasTwoLinesTitle? '0.6rem' : '0'};

  .${GAME_BOX}:hover &{
    &.${ENABLE_HOVER_ANIMATION} {
        transform: translateY(6rem);
        opacity: 0;
    }
    
`;
